import { createAsyncAction } from 'src/redux/actions';

export const UPDATE_REPOSITORY_BUILD_STATUSES = createAsyncAction(
  'dashboard/update-repositories-with-build-status'
);
